export const createMap = (map) => {
  return (dispatch, getState, {getFirestore, getFirebase}) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    const authorDisplayName = firebase.auth().currentUser.displayName;
    const authorId = firebase.auth().currentUser.uid;
    firestore.collection('maps').add({
      ...map,
      authorDisplayName: authorDisplayName,
      authorId: authorId,
      createdAt: new Date()
    }).then(() => {
      dispatch({ type: 'CREATE_MAP_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'CREATE_MAP_ERROR' }, err);
    });
  }
};

export const deleteMap = (map) => {
  return (dispatch, getState, {getFirestore}) => {
    const firestore = getFirestore();
    firestore.delete({ collection: 'maps', doc: map }).then(() => {
      dispatch({ type: 'DELETE_MAP_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'DELETE_MAP_ERROR' }, err);
    });
  }
};

export const saveMap = (map, userID) => {
  return (dispatch, getState, {getFirestore}) => {
    console.log(map)
    console.log(userID)
    const firestore = getFirestore();
    console.log(firestore)
    console.log(getState)
    const updatedMaps = {

    }
    firestore.update({ collection: 'maps', doc: map }, updatedMaps).then(() => {
      dispatch({ type: 'SAVE_MAP_SUCCESS' });
    }).catch(err => {
      dispatch({ type: 'SAVE_MAP_ERROR' }, err);
    });
  }
};


// WEBPACK FOOTER //
// ./src/store/actions/mapActions.js